import { isNative } from '@/lib/capacitor';

// process.env.NODE_ENV is string-replaced by Vite at build time
// (vite.config `define`); declare the global here so no-undef passes.
/* global process */

const firebaseConfig = {
  apiKey: 'AIzaSyCnDJFOziDL8WyM9-O9sB0yud1JhPRYKKk',
  authDomain: 'boskoapps.firebaseapp.com',
  projectId: 'boskoapps',
  storageBucket: 'boskoapps.firebasestorage.app',
  messagingSenderId: '746144360255',
  appId: '1:746144360255:web:fab5faa05f855bc235558a',
  measurementId: 'G-7F56WYB4NZ',
};

let webAnalytics = null;
let webAnalyticsApi = null;

// Native builds use @capacitor-firebase/analytics (wraps the native SDK with
// the platform's GoogleService-Info.plist / google-services.json). Initializing
// the JS SDK there would double-count and miss device-level signals.
export async function initFirebaseWeb({ pageLocation, pageReferrer } = {}) {
  if (isNative()) return null;
  // Only the production build streams to GA4. Vite dev (the local dev server
  // and the Claude preview) runs with NODE_ENV !== 'production', so its traffic
  // never reaches the single production property (G-7F56WYB4NZ) — otherwise a
  // preview session's test hits land as real events and pollute conversion
  // metrics / key-event decisions. Native prod loads the built bundle from
  // bosko.app (NODE_ENV === 'production'), so real native analytics is on.
  // (process.env.NODE_ENV, not import.meta.env — Vite replaces it in the client
  // bundle AND jest can parse it, since firebase.js loads unmocked in several
  // suites via @/lib/analytics; matches the idiom in lib/tab-navigation.js.)
  if (process.env.NODE_ENV !== 'production') return null;
  if (webAnalytics) return webAnalytics;
  const [{ initializeApp }, analyticsApi] = await Promise.all([
    import('firebase/app'),
    import('firebase/analytics'),
  ]);
  const app = initializeApp(firebaseConfig);
  // Disable Firebase's auto page_view — it only fires once on document load,
  // which misses every Inertia SPA navigation. We fire page_view manually on
  // each `router.on('navigate', ...)` event (Inertia fires that on the initial
  // visit too), so GA4 gets exactly one page_view per route with up-to-date
  // page_location / page_title.
  // allow_google_signals / allow_ad_personalization_signals: analytics is used for
  // product metrics only, never advertising. Disabling these keeps GA4 from building
  // cross-device / ad-personalization profiles, so the app does not "track" users in
  // Apple's sense (Guideline 5.1.2) and the "not used to track you" privacy label
  // stays accurate.
  webAnalytics = analyticsApi.initializeAnalytics(app, {
    config: {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      ...(pageLocation ? { page_location: pageLocation } : {}),
      ...(pageReferrer !== undefined ? { page_referrer: pageReferrer } : {}),
    },
  });
  webAnalyticsApi = analyticsApi;
  return webAnalytics;
}

export function logWebEvent(name, params) {
  if (!webAnalytics || !webAnalyticsApi) return false;
  webAnalyticsApi.logEvent(webAnalytics, name, params);
  return true;
}

export function setWebUser(userId, properties) {
  if (!webAnalytics || !webAnalyticsApi) return false;
  webAnalyticsApi.setUserId(webAnalytics, userId);
  webAnalyticsApi.setUserProperties(webAnalytics, properties);
  return true;
}

export function clearWebUser() {
  return setWebUser(null, {
    user_plan: null,
    user_language: null,
  });
}

export function setWebDefaultEventParameters(params) {
  if (!webAnalytics || !webAnalyticsApi) return false;
  webAnalyticsApi.setDefaultEventParameters(params);
  return true;
}
